<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card v-else min-width="350">
        <template v-if="payment.account.logo">
          <v-card-title class="py-4 text-center">
            <v-spacer />
            <v-sheet rounded outlined>
              <v-responsive class="align-center" :aspect-ratio="1/1">
                <v-sheet class="px-1" width="100">
                  <v-img :src="payment.account.logo" width="100%" />
                </v-sheet>
              </v-responsive>
            </v-sheet>
            <v-spacer />
          </v-card-title>
          <v-divider />
        </template>
        <v-card-subtitle>
          <v-toolbar class="mx-n2" color="transparent" flat height="18">
            <v-toolbar-items class="pr-4">
              <v-btn @click="$router.push({ name: 'PaymentRetrieve' })" :disabled="loaderPay" text color="primary"><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-toolbar-items>
            <v-toolbar-title>
              <span class="body-1 text--secondary font-weight-medium">{{payment.amount | currency(payment.currency)}} {{payment.currency}}<v-icon color="secondary">mdi-circle-small</v-icon>{{payment.description}}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="background">
          <v-row no-gutters align="center" justify="start">
            <v-col cols="12" class="py-6 text-center">
              <v-progress-circular indeterminate :color="payment.account.color_background" />
              <span class="d-block mt-2 text--secondary font-weight-medium">Redireccionando a WebPay</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import GatewayViewMixin from '@/mixins/GatewayViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  inject: ['theme'],
  components: {
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GatewayViewMixin,
    GenericViewMixin
  ],
  computed: mapState({
    payment: state => cloneDeep(state.payments.payDetail),
    source: state => cloneDeep(state.payments.sourcesDetail),
    paymentsDetail: state => state.payments.paymentsDetail
  }),
  created () {
    this.loaderPay = true
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .then(() => {
      if (this.payment.status === 'succeeded' || !this.payment.gateways.includes('webpay')) {
        this.$router.push({ name: 'PaymentRetrieve' })
        return false
      } else {
        this.payExternalGateway('webpay')
      }
    })
  }
}
</script>